module.exports = __webpack_public_path__ + "assets/img/block-hover-d094e72e.png";